/* eslint-disable standard/object-curly-even-spacing */

import { getBrandData, getGoodsMarketCategoryListData, getTopProductDistributionList, getTopDistributionList, getGoodsProductCommentData, getGoodsProductHitData, getGoodsProductHitAreaData, getGoodsProductCommentAreaData, getGoodsDetailData, getSimilarFormulationData, getRecommendFormulationData, getRelatedBasfProductData, getRecommendProductData, getInterestingProductData, getProductListData, getBrandListData, getSearchByLetterListData, getSubCategoryListData, getMarketCategoryListData, getGoodsFormsListData, getGoodsAspectsListData, getGoodsSpaListData, getGoodsPaListData, getSimilarFormulationList, getUpdateItem, getCommentKeywords } from '@/axios/api/consumerProducts'
import { Message } from 'element-ui'
// const REMOTEBEVOLGROUPBRANDS = 'REMOTEBEVOLGROUPBRANDS'
const UPDATE_GOODSFORMLISTDATA = 'UPDATE_GOODSFORMLISTDATA'
const UPDATE_GOODSASPECTSLISTDATA = 'UPDATE_GOODSASPECTSLISTDATA'
const UPDATE_GOODSSPALISTDATA = 'UPDATE_GOODSSPALISTDATA'
const UPDATE_GOODSPALISTDATA = 'UPDATE_GOODSPALISTDATA'
const UPDATE_SUBCATEGORYLISTDATA = 'UPDATE_SUBCATEGORYLISTDATA'
const UPDATE_MARKETCATEGORYLISTDATA = 'UPDATE_MARKETCATEGORYLISTDATA'
const UPDATE_SEARCHBYLETTERLISTDATA = 'UPDATE_SEARCHBYLETTERLISTDATA'
const UPDATE_BRANDLISTDATA = 'UPDATE_BRANDLISTDATA'
const UPDATE_PRODUCTLISTDATA = 'UPDATE_PRODUCTLISTDATA'
const UPDATE_DISCRIPTIONLISTDATA = 'UPDATE_DISCRIPTIONLISTDATA'
const UPDATE_BRAND_SEARCH_LIST = 'UPDATE_BRAND_SEARCH_LIST'

const UPDATE_GETGOODSDETAILDATA = 'UPDATE_GETGOODSDETAILDATA'
const UPDATE_GETSIMILARFORMULATIONDATA = 'UPDATE_GETSIMILARFORMULATIONDATA'
const UPDATE_GETSIMILARFORMULATIONLIST = 'UPDATE_GETSIMILARFORMULATIONLIST'
const UPDATE_GETRECOMMENDFORMULATIONDATA = 'UPDATE_GETRECOMMENDFORMULATIONDATA'
const UPDATE_GETRELATEDBASFPRODUCTDATA = 'UPDATE_GETRELATEDBASFPRODUCTDATA'
const UPDATE_GETRECOMMENDPRODUCTDATA = 'UPDATE_GETRECOMMENDPRODUCTDATA'
const UPDATE_GETINTERESTINGPRODUCTDATA = 'UPDATE_GETINTERESTINGPRODUCTDATA'
const UPDATE_GETTOPPRODUCTDISTRIBUTIONDATA = 'UPDATE_GETTOPPRODUCTDISTRIBUTIONDATA'
// const UPDATE_GETTOPPRODUCTPARAMDATA = 'UPDATE_GETTOPPRODUCTPARAMDATA'
const UPDATE_GETTOPDISTRIBUTIONDATA = 'UPDATE_GETTOPDISTRIBUTIONDATA'
const UPDATE_GETGOODSMARKETCATEGORYDATA = 'UPDATE_GETGOODSMARKETCATEGORYDATA'
const UPDATE_NEWLOADING = 'UPDATE_NEWLOADING'
const UPDATE_TableLOADING = 'UPDATE_TableLOADING'
// const UPDATE_GETRELATEDBASFDATA = 'UPDATE_GETRELATEDBASFDATA'
/**  商品详情-评论聚合 */
const UPDATE_GOODSPRODUCTCOMMENTDATA = 'UPDATE_GOODSPRODUCTCOMMENTDATA'
/** 商品详情-商品点击 */
const UPDATE_GOODSPRODUCTHITDATA = 'UPDATE_GOODSPRODUCTHITDATA'
const UPDATE_GOODSPRODUCTHITDETAILDATA = 'UPDATE_GOODSPRODUCTHITDETAILDATA'
/**  商品详情-点击区域 */
const UPDATE_GOODSPRODUCTHITAREADATA = 'UPDATE_GOODSPRODUCTHITAREADATA'
/**  商品详情-评论区域 */
const UPDATE_GOODSPRODUCTCOMMENTAREADATA = 'UPDATE_GOODSPRODUCTCOMMENTAREADATA'
const UPDATE_GOODSPRODUCTCOMMENTAREADETAILDATA = 'UPDATE_GOODSPRODUCTCOMMENTAREADETAILDATA'
// 分页
const UPDATE_TOTAL = 'UPDATE_TOTAL'
const UPDATE_REAL_TOTAL = 'UPDATE_REAL_TOTAL'
const UPDATE_SEARCH = 'UPDATE_SEARCH'
const UPDATE_SEARCH_CLAIM_LIST = 'UPDATE_SEARCH_CLAIM_LIST'
const state = {
  productListData: [],
  goodsFormListData: [],
  goodsAspectsListData: [],
  goodsSpaListData: [],
  goodsPaListData: [],
  subCategoryListData: [],
  marketCategoryListData: [],
  searchByLetterListData: [],
  brandListData: [],
  topProductListData: [],
  brandSearchList: [],
  // topProductParam: {
  //   tabType: 'prdClaimForm'
  // },
  topDiscriptionListData: [],
  goodsMarketCategoryData: [],
  newLoading: false,
  tableLoading: false,
  // relatedBasfListData: [],
  // searchListParams: {
  //   pid2: null
  // }
  /** 根据产品查详细页 */
  goodsDetailData: {
    productBrandVo: {}
  },
  /** 根据产品查询相似配方 */
  similarFormulationData: [],
  /** 产品列表推荐配方 */
  recommendFormulationData: [],
  /**   关联BASF产品 */
  relatedBasfProductData: [],
  /**  产品详情推荐产品 */
  recommendProductData: [],
  /**  商品详情-推荐产品 */
  goodsInterestingProductData: [],
  /**  商品详情-评论聚合 */
  goodsProductCommentData: {
    commentScore: []
  },
  /** 商品详情-商品点击 */
  goodsProductHitData: {
    hitSkin: []
  },
  /**  商品详情-点击区域 */
  goodsProductHitAreaData: [],
  goodsProductHitDetailAreaData: [],
  /**  商品详情-评论区域 */
  goodsProductCommentAreaData: [],
  goodsProductCommentDetailAreaData: [],
  // 分页 参数
  pager: {
    current: 1,
    size: 10,
    total: 0,
    realTotal: 0
  },
  pageParam: {

  },
  // detailListData
  // remoteBevolGroupBrands: [],             //原bevolBrandByBrandNameAction    state.remoteBevolGroupBrands   品牌模糊搜索
  // bevolProductCategories: [],
  // brndGroups: [],
  // bevolProductAllCategories: [],
  // bevolProductForms: [],
  // bevolProductAspects: [],
  // bevolSuncreenLevels: [],
  // bevolSpfs: [],
  // bevolSpecificPopuGroups: [],
  // bevolApplicationAreas: [],
  // bevolGoodsClaims: []
  similarClaimData: [],
  similarFormulationList: [],
  searchedClaimList: []
}

const getters = {
  productListData: state => state.productListData,
  goodsFormListData: state => state.goodsFormListData,
  goodsAspectsListData: state => state.goodsAspectsListData,
  goodsSpaListData: state => state.goodsSpaListData,
  goodsPaListData: state => state.goodsPaListData,
  subCategoryListData: state => state.subCategoryListData.map(v => {
    return { title: v.name, id: v.id }
  }),
  marketCategoryListData: state => state.marketCategoryListData,
  searchByLetterListData: state => state.searchByLetterListData,
  brandListData: state => state.brandListData,
  topProductListData: state => state.topProductListData,
  topProductParam: state => state.topProductParam,

  topDiscriptionListData: state => state.topDiscriptionListData,
  goodsMarketCategoryData: state => state.goodsMarketCategoryData,
  goodsProductHitDetailAreaData: state => state.goodsProductHitDetailAreaData,
  goodsProductCommentDetailAreaData: state => state.goodsProductCommentDetailAreaData,
  // 分页
  pager: state => state.pager,
  param: state => state.param,
  pageParam: state => state.pageParam,
  newLoading: state => state.newLoading,
  tableLoading: state => state.tableLoading,
  similarClaimData: state => state.similarClaimData,
  // relatedBasfListData: state => state.relatedBasfListData,
  /** 根据产品查详细页 */
  goodsDetailData: state => state.goodsDetailData,
  /** 根据产品查询相似配方 */
  similarFormulationData: state => state.similarFormulationData,
  similarFormulationList: state => state.similarFormulationList,
  /** 产品列表推荐配方 */
  recommendFormulationData: state => state.recommendFormulationData,
  /**   关联BASF产品 */
  relatedBasfProductData: state => state.relatedBasfProductData,
  /**  产品详情推荐产品 */
  recommendProductData: state => state.recommendProductData,
  /**  商品详情-推荐产品 */
  goodsInterestingProductData: state => state.goodsInterestingProductData,
  /**  商品详情-评论聚合 */
  goodsProductCommentData: state => state.goodsProductCommentData,
  /**  品牌 */
  brandSearchList: state => state.brandSearchList.map(v => {
    return { label: v.name, value: v.id }
  }),
  /** 商品详情-商品点击 */
  goodsProductHitData: state => {
    const { hitMonth, hitAge } = { ...state.goodsProductHitData }
    return {
      hitMonth,
      hitAge,
      hitSkin: state.goodsProductHitData.hitSkin.map(v => {
        return { comment_num: v.hit_num, skin: v.skin }
      })
    }
  },
  /**  商品详情-点击区域 */
  goodsProductHitAreaData: state => state.goodsProductHitAreaData,
  /**  商品详情-评论区域 */
  goodsProductCommentAreaData: state => state.goodsProductCommentAreaData,
  searchedClaimList: state => state.searchedClaimList
  // remoteBevolGroupBrands: state => state.remoteBevolGroupBrands,
  // bevolProductCategories: state => state.bevolProductCategories,
  // brndGroups: state => state.brndGroups,
  // bevolProductAllCategories: state => state.bevolProductAllCategories,
  // bevolProductForms: state => state.bevolProductForms,
  // bevolProductAspects: state => state.bevolProductAspects,
  // bevolSuncreenLevels: state => state.bevolSuncreenLevels,
  // bevolSpfs: state => state.bevolSpfs,
  // bevolSpecificPopuGroups: state => state.bevolSpecificPopuGroups,
  // bevolApplicationAreas: state => state.bevolApplicationAreas,
  // bevolGoodsClaims: state => state.bevolGoodsClaims,
}

const mutations = {
  [UPDATE_GOODSFORMLISTDATA] (state, goodsFormListData) {
    state.goodsFormListData = goodsFormListData
  },
  [UPDATE_GOODSASPECTSLISTDATA] (state, goodsAspectsListData) {
    state.goodsAspectsListData = goodsAspectsListData
  },
  [UPDATE_GOODSSPALISTDATA] (state, goodsSpaListData) {
    state.goodsSpaListData = goodsSpaListData
  },
  [UPDATE_GOODSPALISTDATA] (state, goodsPaListData) {
    state.goodsPaListData = goodsPaListData
  },
  [UPDATE_SUBCATEGORYLISTDATA] (state, subCategoryListData) {
    state.subCategoryListData = subCategoryListData
  },
  [UPDATE_MARKETCATEGORYLISTDATA] (state, marketCategoryListData) {
    state.marketCategoryListData = marketCategoryListData
  },
  [UPDATE_SEARCHBYLETTERLISTDATA] (state, searchByLetterListData) {
    state.searchByLetterListData = searchByLetterListData
  },
  [UPDATE_BRANDLISTDATA] (state, brandListData) {
    state.brandListData = brandListData
  },
  [UPDATE_PRODUCTLISTDATA] (state, productListData) {
    state.productListData = productListData
  },
  [UPDATE_DISCRIPTIONLISTDATA] (state, discriptionListData) {
    state.discriptionListData = discriptionListData
  },
  [UPDATE_GETTOPPRODUCTDISTRIBUTIONDATA] (state, topProductListData) {
    state.topProductListData = topProductListData
  },
  // [UPDATE_GETTOPPRODUCTPARAMDATA] (state, topProductParam) {
  //   state.topProductParam = { ...state.topProductParam, topProductParam}
  // },
  [UPDATE_GETTOPDISTRIBUTIONDATA] (state, topDiscriptionListData) {
    state.topDiscriptionListData = topDiscriptionListData
  },
  [UPDATE_GETGOODSMARKETCATEGORYDATA] (state, goodsMarketCategoryData) {
    state.goodsMarketCategoryData = goodsMarketCategoryData
  },
  [UPDATE_GOODSPRODUCTHITDETAILDATA] (state, goodsProductHitDetailAreaData) {
    state.goodsProductHitDetailAreaData = goodsProductHitDetailAreaData
  },
  [UPDATE_GOODSPRODUCTCOMMENTAREADETAILDATA] (state, goodsProductCommentDetailAreaData) {
    state.goodsProductCommentDetailAreaData = goodsProductCommentDetailAreaData
  },
  [UPDATE_NEWLOADING] (state, newLoading) {
    state.newLoading = newLoading
  },
  [UPDATE_TableLOADING] (state, tableLoading) {
    state.tableLoading = tableLoading
  },
  // 分页
  [UPDATE_TOTAL] (state, total) {
    state.pager = { ...state.pager, total }
  },
  [UPDATE_REAL_TOTAL] (state, realTotal) {
    state.pager = { ...state.pager, realTotal }
  },
  // 分页 查询
  [UPDATE_SEARCH] (state, { pager, pageParam }) {
    state.pager = pager
    if (pageParam) state.pageParam = pageParam
  },

  /** 根据产品查详细页 */
  [UPDATE_GETGOODSDETAILDATA] (state, goodsDetailData) {
    const productBrandVo = goodsDetailData.productBrandVo || {}
    state.goodsDetailData = {
      ...goodsDetailData,
      productBrandVo
    }
  },
  /** 根据产品查询相似配方 */
  [UPDATE_GETSIMILARFORMULATIONDATA] (state, similarFormulationData) {
    state.similarFormulationData = similarFormulationData
  },
  [UPDATE_GETSIMILARFORMULATIONLIST] (state, similarFormulationList) {
    state.similarFormulationList = similarFormulationList
  },
  /** 产品列表推荐配方 */
  [UPDATE_GETRECOMMENDFORMULATIONDATA] (state, recommendFormulationData) {
    state.recommendFormulationData = recommendFormulationData
  },
  /**   关联BASF产品 */
  [UPDATE_GETRELATEDBASFPRODUCTDATA] (state, relatedBasfProductData) {
    state.relatedBasfProductData = relatedBasfProductData
  },
  /**  产品详情推荐产品 */
  [UPDATE_GETRECOMMENDPRODUCTDATA] (state, recommendProductData) {
    state.recommendProductData = recommendProductData
  },
  /**  商品详情-推荐产品 */
  [UPDATE_GETINTERESTINGPRODUCTDATA] (state, goodsInterestingProductData) {
    state.goodsInterestingProductData = goodsInterestingProductData
  },
  /**  商品详情-评论聚合 */
  [UPDATE_GOODSPRODUCTCOMMENTDATA] (state, goodsProductCommentData) {
    state.goodsProductCommentData = goodsProductCommentData
  },
  /** 商品详情-商品点击 */
  [UPDATE_GOODSPRODUCTHITDATA] (state, goodsProductHitData) {
    state.goodsProductHitData = goodsProductHitData
  },
  /**  商品详情-点击区域 */
  [UPDATE_GOODSPRODUCTHITAREADATA] (state, goodsProductHitAreaData) {
    state.goodsProductHitAreaData = goodsProductHitAreaData
  },
  /**  商品详情-评论区域 */
  [UPDATE_GOODSPRODUCTCOMMENTAREADATA] (state, goodsProductCommentAreaData) {
    state.goodsProductCommentAreaData = goodsProductCommentAreaData
  },
  /**  品牌 */
  [UPDATE_BRAND_SEARCH_LIST] (state, brandSearchList) {
    state.brandSearchList = brandSearchList
  },
  [UPDATE_SEARCH_CLAIM_LIST] (state, searchedClaimList) {
    state.searchedClaimList = searchedClaimList
  }
}

const actions = {
  async goodsFormListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsFormsListData()
      commit(UPDATE_GOODSFORMLISTDATA, res || [])
    } catch (e) { }
  },
  async getGoodsAspectsListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsAspectsListData()
      commit(UPDATE_GOODSASPECTSLISTDATA, res || [])
    } catch (e) { }
  },
  async getGoodsSpaListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsSpaListData()
      commit(UPDATE_GOODSSPALISTDATA, res || [])
    } catch (e) { }
  },
  async getGoodsPaListDataApi ({ commit }) {
    try {
      let { data: res } = await getGoodsPaListData()
      commit(UPDATE_GOODSPALISTDATA, res || [])
    } catch (e) { }
  },
  async getSubCategoryListDataApi ({ commit }, params) {
    try {
      let { data: res } = await getSubCategoryListData(params)
      commit(UPDATE_SUBCATEGORYLISTDATA, res || [])
    } catch (e) { }
  },
  async getMarketCategoryListDataApi ({ commit }) {
    try {
      let { data: res } = await getMarketCategoryListData()
      commit(UPDATE_MARKETCATEGORYLISTDATA, res || [])
    } catch (e) { }
  },
  async getSearchByLetterListDataApi ({ commit }, params) {
    try {
      let { data: res } = await getSearchByLetterListData({ ...params, tname: 'goods' })
      commit(UPDATE_SEARCHBYLETTERLISTDATA, res || [])
    } catch (e) { }
  },
  async getBrandListDataApi ({ commit }, params) {
    try {
      let { data: res } = await getBrandListData(params)
      commit(UPDATE_BRANDLISTDATA, res || [])
    } catch (e) { }
  },
  async getProductListDataApi ({ state, commit }, params) {

    commit(UPDATE_TableLOADING, true)
    try {
      let { data: res } = await getProductListData({ ...params })
      commit(UPDATE_PRODUCTLISTDATA, res || [])
      commit(UPDATE_TOTAL, res.total)
      commit(UPDATE_REAL_TOTAL, res.realTotal)
    } catch (e) { }
    commit(UPDATE_TableLOADING, false)
  },
  // 清空搜索条件
  clearSearchApi ({ state, commit }) {
    const pager = {
      ...state.pager,
      current: 1
    }
    const params = {
      ...state.pageParam
      // id: '',
      // account: '',
      // phone: '',
      // email: '',
      // roleId: '',
      // dataStatus: ''
    }
    commit(UPDATE_SEARCH, { pager, params })
  },
  // 分页 设置page
  setPagerApi ({ commit }, pager) {
    commit(UPDATE_SEARCH, { pager })
  },
  async getTopProductDistributionListDataApi ({ commit }, params) {
    commit(UPDATE_NEWLOADING, true)
    try {
      let { data: res } = await getTopProductDistributionList({ ...params })
      return res
      commit(UPDATE_GETTOPPRODUCTDISTRIBUTIONDATA, res)
    } catch (e) { }
    commit(UPDATE_NEWLOADING, false)
  },
  async getTopDistributionListDataApi ({ commit }, params) {
    commit(UPDATE_NEWLOADING, true)
    try {
      let { data: res } = await getTopDistributionList(params)
      commit(UPDATE_GETTOPDISTRIBUTIONDATA, res || [])
      return res || []
    } catch (e) { }
    commit(UPDATE_NEWLOADING, false)
  },
  async getGoodsMarketCategoryListDataApi ({ commit }, params) {
    try {
      let { data: res } = await getGoodsMarketCategoryListData(params)
      commit(UPDATE_GETGOODSMARKETCATEGORYDATA, res || [])
    } catch (e) { }
  },

  /** 根据产品查详细页 */
  async getGoodsDetailDataApi ({ commit }, params) {
    // commit(UPDATE_NEWLOADING, true)
    try {
      let { data: res } = await getGoodsDetailData(params)
      commit(UPDATE_GETGOODSDETAILDATA, res)
      return res;
    } catch (e) { }
    // commit(UPDATE_NEWLOADING, false)
  },
  /** 根据产品查询相似配方 */
  async getSimilarFormulationDataApi ({ commit }, params) {
    try {
      let { data: res } = await getSimilarFormulationData(params)
      commit(UPDATE_GETSIMILARFORMULATIONDATA, res || [])
    } catch (e) { }
  },
  /** 根据产品查询相似配方 */
  async getSimilarFormulationListApi ({ commit }, params) {
    try {
      let { data: res } = await getSimilarFormulationList(params)
      commit(UPDATE_GETSIMILARFORMULATIONLIST, res || [])
    } catch (e) { }
  },
  /** 产品列表推荐配方 */
  async getRecommendFormulationDataApi ({ commit }, params) {
    try {
      let { data: res } = await getRecommendFormulationData(params)
      commit(UPDATE_GETRECOMMENDFORMULATIONDATA, res || [])
    } catch (e) { }
  },
  /**   关联BASF产品 */
  async getRelatedBasfProductDataApi ({ commit }, params) {
    try {
      let { data: res } = await getRelatedBasfProductData(params)
      commit(UPDATE_GETRELATEDBASFPRODUCTDATA, res || [])
    } catch (e) { }
  },
  /**  产品详情推荐产品 */
  async getRecommendProductDataApi ({ commit }, params) {
    try {
      let { data: res } = await getRecommendProductData(params)
      commit(UPDATE_GETRECOMMENDPRODUCTDATA, res || [])
    } catch (e) { }
  },
  /**  商品详情-推荐产品 */
  async getInterestingProductDataApi ({ commit }, params) {
    try {
      let { data: res } = await getInterestingProductData(params)
      commit(UPDATE_GETINTERESTINGPRODUCTDATA, res || [])
    } catch (e) { }
  },
  /**  商品详情-评论聚合 */
  async getGoodsProductCommentDataApi ({ commit }, params) {
    try {
      let { data: res } = await getGoodsProductCommentData(params)
      commit(UPDATE_GOODSPRODUCTCOMMENTDATA, res)
    } catch (e) { }
  },
  /** 商品详情-商品点击 */
  async getGoodsProductHitDataApi ({ commit }, params) {
    try {
      let { data: res } = await getGoodsProductHitData(params)
      commit(UPDATE_GOODSPRODUCTHITDATA, res)
    } catch (e) { }
  },
  /**  商品详情-点击区域 */
  async getGoodsProductHitAreaDataApi ({ commit }, params) {
    try {
      let { data: res } = await getGoodsProductHitAreaData(params)
      commit(UPDATE_GOODSPRODUCTHITAREADATA, res || [])
    } catch (e) { }
  },
  /**  商品详情-评论区域 */
  async getGoodsProductCommentAreaDataApi ({ commit }, params) {
    try {
      let { data: res } = await getGoodsProductCommentAreaData(params)
      commit(UPDATE_GOODSPRODUCTCOMMENTAREADATA, res || [])
    } catch (e) { }
  },

  /**  品牌  */
  async getBrandSearchApi ({ commit }, params) {
    try {
      let { data: res } = await getBrandData({ keyword: params, size: 10 })
      commit(UPDATE_BRAND_SEARCH_LIST, res || [])
      return res
    } catch (e) { }
  },
  async getUpdateItemApi ({ commit }, params) {
    try {
      let { data: res } = await getUpdateItem()
      return res
    } catch (e) { }
  },
  async getCommentKeywordsApi ({ commit }, params) {
    try {
      let { data: res } = await getCommentKeywords(params)
      return res || []
    } catch (e) { }
  },
  // 获取宣称
  async searchClaimDataByTitleApi ({ commit }, params) {
    try {
      const { data: res } = await getSearchByLetterListData({title: params, tname: 'goods'})
      commit(UPDATE_SEARCH_CLAIM_LIST, (res || []).map(v => {
        return {
          id: v.id,
          title: v.title
        }
      }))
    } catch (e) {
      commit(UPDATE_SEARCH_CLAIM_LIST, [])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/consumerProducts.js